<template>
  <v-form>
    <v-data-table
      :headers="headers"
      disable-filtering
      disable-pagination
      disable-sort
      hide-default-footer
      no-data-text=""
    >
      <template v-slot:body.prepend>
        <tr>
          <td>
            <employees-filter
              v-model="filter.employee"
              :item-text="getEmployeeName"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              multiple
              chips
              small-chips
              deletable-chips
            />
          </td>

          <td>
            <region-input
              v-model="filter.regions"
              :label="$t('DATA_TABLE.FILTER')"
            />
          </td>

          <td>
            <v-menu
              ref="menuDateFrom"
              v-model="menuDateFrom"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateFrom | dateFormat"
                  :label="$t('DATA_TABLE.FILTER')"
                  append-icon="mdi-calendar"
                  clearable
                  readonly
                  role="button"
                  autocomplete="nope"
                  @click:clear="clear_from"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="dateFrom"
                min="1940-01-01"
                first-day-of-week="1"
                @change="saveDatefrom"
              />
            </v-menu>
          </td>
          <td>
            <v-menu
              ref="menuDateTo"
              v-model="menuDateTo"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateTo | dateFormat"
                  :label="$t('DATA_TABLE.FILTER')"
                  append-icon="mdi-calendar"
                  clearable
                  readonly
                  role="button"
                  autocomplete="nope"
                  @click:clear="clear_to"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                ref="picker"
                v-model="dateTo"
                :min="dateFrom || '1940-01-01'"
                first-day-of-week="1"
                @change="saveDateto"
              />
            </v-menu>
          </td>
          <td>
            <v-select
              v-model="filter.status"
              :items="statuses"
              item-text="name"
              item-value="id"
              :label="$t('DATA_TABLE.FILTER')"
              :loading="loading"
              clearable
              multiple
              chips
              small-chips
              deletable-chips
            >
              <template v-slot:selection="data">
                <v-chip
                  text-color="white"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :color="data.item.color"
                  small
                  close
                  @click="data.select"
                  @click:close="remove(data.item, filter.status)"
                >
                  {{ data.item.name }}
                </v-chip>
              </template>
            </v-select>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn color="grey" depressed outlined @click="reset" v-on="on">
                  <v-icon>mdi-filter-remove</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('BUTTON.CLEAR_FILTER') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-btn
              color="primary"
              depressed
              type="submit"
              @click.prevent="refreshData"
            >
              {{ $t('BUTTON.FIND') }}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-form>
</template>
<script>
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';
import { debounce, cloneDeep, isEmpty } from 'lodash';
import { dateFormat } from '@/modules/_global/filters';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';
import EmployeesFilter from '@/modules/request_vacations/components/filters/EmployeesFilter.vue';
import RegionInput from '@/modules/_global/_components/region/RegionInput.vue';

export default {
  name: 'RequestVacationsFilterForm',
  components: { RegionInput, EmployeesFilter },

  filters: {
    dateFormat
  },

  mixins: [i18nRefreshData],

  props: {},

  data() {
    return {
      expensiveFunc: null,
      unwatch: null,
      delay: 0,

      service: null,
      services: [],

      menuDateFrom: false,
      dateFrom: null,
      menuDateTo: false,
      dateTo: null,

      status: [],
      statuses: [],

      filter: {}
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('request_vacations', ['requestVacationsFilters']),
    headers() {
      return [
        {
          text: this.$t('EMPLOYEES.ITEM'),
          sortable: false
        },
        {
          text: this.$t('REGIONS.ITEMS'),
          sortable: false
        },
        {
          text: this.$t('ITEM.DATE_FROM'),
          sortable: false
        },
        {
          text: this.$t('ITEM.DATE_TO'),
          sortable: false
        },
        {
          text: this.$t('ITEM.STATUS'),
          sortable: false
        },
        {
          text: '',
          sortable: false
        },
        {
          text: '',
          sortable: false
        }
      ];
    },
    debouncedRequest() {
      return debounce(this.expensiveFunc, this.delay);
    },
    filterData() {
      let filtered = Object.entries(this.filter).filter(
        ([, value]) =>
          !(
            value === null ||
            value === '' ||
            (Array.isArray(value) && value.length === 0)
          )
      );

      return Object.fromEntries(filtered);
    }
  },

  watch: {
    dateTo(val) {
      if (val) {
        this.filter = { ...this.filter, date_to: val };
      } else {
        this.filter.date_to = null;
      }
    },

    dateFrom(val) {
      if (val) {
        this.filter = { ...this.filter, date_from: val };
      } else {
        this.filter.date_from = null;
      }
    }
  },

  mounted() {
    if (!isEmpty(this.requestVacationsFilters)) {
      this.filter = cloneDeep(this.requestVacationsFilters);

      this.status = this.filter.status;
      this.dateFrom = this.filter.date_from;
      this.dateTo = this.filter.date_to;
    }
    this.getDataStatuses();

    this.refreshData();
    this.setDelay(500);
  },

  methods: {
    ...mapCacheActions('request_vacations', ['getStatuses']),

    getDataStatuses() {
      this.getStatuses().then(({ data }) => {
        this.statuses = data.data;
      });
    },

    clear_from() {
      this.dateFrom = null;
    },
    clear_to() {
      this.dateTo = null;
    },

    saveDatefrom(date) {
      this.$refs.menuDateFrom.save(date);
    },

    saveDateto(date) {
      this.$refs.menuDateTo.save(date);
    },

    expensiveOperation: function() {
      return this.debouncedRequest();
    },

    setDelay(v) {
      this.delay = v;
    },

    refreshData() {
      this.$emit('setFilters', cloneDeep(this.filterData));
    },

    remove(item, obj) {
      const index = obj.indexOf(item.id);
      if (index >= 0) obj.splice(index, 1);
    },

    reset() {
      this.menuDateFrom = false;
      this.dateFrom = null;
      this.menuDateTo = false;
      this.dateTo = null;

      this.status = null;

      this.filter = {};

      this.refreshData();
    },

    getEmployeeName(item) {
      return `${item.first_name} ${item.last_name}`.trim();
    }
  }
};
</script>
